import { render, staticRenderFns } from "./UserSurveyResults.vue?vue&type=template&id=e2c87fb4&"
import script from "./UserSurveyResults.vue?vue&type=script&lang=js&"
export * from "./UserSurveyResults.vue?vue&type=script&lang=js&"
import style0 from "./UserSurveyResults.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports